/**
 * MCP OAuth consent endpoints.
 *
 * The pending-request handle travels in the request body rather than the URL
 * so it stays out of access logs and referrers. It is short-lived and decides
 * nothing on its own — approving still requires a signed-in administrator.
 */

import { fetchApi } from '../core';
import type {
  AuthorizationDecisionData,
  AuthorizationDecisionResponse,
  PendingAuthorizationResponse,
} from '../types';

/** What the signed-in administrator is being asked to approve. */
export function describeAuthorization(handle: string, componentName: string = 'Unknown') {
  return fetchApi<PendingAuthorizationResponse>(
    '/tenant/oauth/authorizations/describe',
    { method: 'POST', body: JSON.stringify({ request: handle }) },
    componentName
  );
}

/** Approve or deny. The server returns the URL to send the browser back to. */
export function decideAuthorization(
  data: AuthorizationDecisionData,
  componentName: string = 'Unknown'
) {
  return fetchApi<AuthorizationDecisionResponse>(
    '/tenant/oauth/authorizations/decide',
    { method: 'POST', body: JSON.stringify(data) },
    componentName
  );
}
